import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';

import { useDispatch } from 'react-redux';

import { Router } from '../../i18n';

import { getCountryBySlug } from '../../config/country-slug';
import { Providers } from '../../config/providers';
import { getProviderCountry } from '../../config/countries';

import * as fromProviders from '../../entities/providers/actions';
import { actions as fromRates } from '../../entities/rates';

import { StaticPageLayout } from '../../layouts/static-page.layout';

import { Layout } from '../../components/element';

import { RatesFilter } from '../../components/rates/filters';
import { Stepper } from '../../components/rates/stepper';
import { CryptoSDKLoader } from '../../components/scripts-loader';
import { useAutoSelectService } from '../../components/rates/stepper/hooks/useAutoSelectService';

const Rates: React.FC = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    const {
      query: { provider, weight, to },
    } = router;

    const country = getCountryBySlug(String(provider));

    if (to) {
      const inboundCountry = getProviderCountry(to as Providers);

      if (country || inboundCountry) {
        const payload: NotTyped = {};

        if (country) {
          payload.from = country.code;
        }

        if (inboundCountry) {
          payload.to = inboundCountry.code;
        }

        dispatch(fromProviders.setCountryAct(payload));
      } else {
        Router.replace('/rates').then();
      }

      if (Number(weight)) {
        dispatch(fromProviders.setWeightAct({ weight: Number(weight) }));
      }

      dispatch(fromProviders.setMode({ mode: 'delivers' }));
    } else {
      Router.replace('/').then();
    }

    return () => {
      dispatch(fromProviders.fullReset());
      dispatch(fromRates.fullReset());
    };
  }, [router.query]);

  useAutoSelectService();

  return (
    <>
      <Layout.Row gutter={20} className="mb-20">
        <Layout.Col span={24} sm={8} md={8} lg={8}>
          <RatesFilter />
        </Layout.Col>

        <Layout.Col span={24} sm={16} md={16} lg={16}>
          <Stepper />
        </Layout.Col>
      </Layout.Row>
    </>
  );
};

const RatesPage: NextPage = () => (
  <StaticPageLayout>
    <Rates />
    <CryptoSDKLoader />
  </StaticPageLayout>
);

RatesPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'kb', 'rates'],
});

export default RatesPage;
